<template>
  <ul class="osk-product-attributes">
    <h2 class="osk-product-attributes__title">
      {{ product.brand?.name }}
      {{ product.shortSeoDescription ?? product.name }}
    </h2>
    <li
      v-if="product.isAtOffice"
      class="osk-product-attributes__item"
    >
      <span class="osk-product-attributes__item-name">
        {{ $t('productAttributes.stockAvailability.firstPart') }}
      </span>

      <span class="attribute__item-value">
        {{ $t('productAttributes.stockAvailability.secondPart') }}
      </span>
    </li>

    <li
      v-if="isSizes"
      class="osk-product-attributes__item"
    >
      <span class="osk-product-attributes__item-name">
        {{ $t('productAttributes.size') }}
      </span>

      <span class="osk-product-attributes__item-value osk-product-attributes__item-value-size">
        {{ sizesText }}
      </span>
    </li>

    <li
      v-for="(attribute, index) in commonAttributes"
      :key="index"
      class="osk-product-attributes__item"
    >
      <span class="osk-product-attributes__item-name">
        {{ attribute.name }}
      </span>

      <span class="osk-product-attributes__item-value">
        {{ attribute.value }}
      </span>
    </li>
  </ul>
</template>

<script setup lang="ts">
import { ProductDTORes } from '~/restAPI/data-contracts';
import { useProduct } from '~/providers/product';

const props = defineProps<{
  product: ProductDTORes
}>();

const {
  commonAttributes, productRealSizes, sizeAttributes, isSizes,
} = useProduct(toRef(props, 'product'));

const sizesText = computed(() => {
  if (!isSizes.value || !productRealSizes.value?.length) return '';

  const sizeType = productRealSizes.value[0].productSizeType;
  const sizeValues = productRealSizes.value.reduce((result, item, index) => {
    if (item.productSizeValue) {
      // eslint-disable-next-line no-param-reassign
      result += `${index !== 0 ? '/' : ''}${item.productSizeValue}`;
    }

    return result;
  }, '');

  return `${sizeType} ${sizeValues}`;
});
</script>

<style lang="scss" scoped>
@import "~/assets/scss/settings/index";

.osk-product-attributes {
  &__title {
    color: $grey;
    margin-bottom: $indent-mlarge;
  }

  &__item {
    display: flex;
    align-items: center;
    justify-content: space-between;
    margin-bottom: 12px;

    @include media-query(lg-and-up) {
      justify-content: flex-start;
    }

    &:last-child {
      margin-bottom: 32px;
    }
  }

  &__item-name {
    width: 176px;
    padding-right: $indent-medium;
    color: $grey;
    flex-shrink: 0;

    @include media-query(lg-and-up) {
      width: 202px;
    }
  }

  &__item-value-size {
    @include overflow-ellipsis;
  }
}
</style>
